import { useContext } from "react";
import { useSelector } from "react-redux";

import { ThemeContext } from "./ThemeProvider";

export const useTheme = () => {
    const { colorTheme } = useSelector(state => state.game);
    const { themeMap } = useContext(ThemeContext);

    return themeMap[colorTheme];
};
